/* assets/giddy-cart-drawer.js */
/* Custom slide-out cart drawer with optimistic UI + per-item debouncing.
   The +/- buttons update the visible quantity instantly, then send a single
   debounced request to Shopify with the final quantity. Rapid clicks no
   longer pile up duplicate requests, and the user never waits for the
   network before seeing their change. */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  var itemsEl = document.getElementById('cart-drawer-items');
  if (!drawer || !overlay || !itemsEl) return;

  var loadingEl = document.getElementById('cart-drawer-loading');
  var emptyEl = document.getElementById('cart-drawer-empty');
  var footerEl = document.getElementById('cart-drawer-footer');
  var totalEl = document.getElementById('cart-drawer-total');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var discountsEl = document.getElementById('cart-drawer-discounts');

  // Per-line-item pending state: { timer, controller, finalQty, basePrice }
  var pending = Object.create(null);
  var DEBOUNCE_MS = 220;
  // Local cache of the last cart payload so we can update the total optimistically
  var lastCart = null;

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Renders the subtotal → box-discount(s) → total breakdown in the footer.
  //   Subtotal = FULL price (cart.original_total_price — base × qty, no
  //              discount). This is what each line item also shows.
  //   Discount = the box discount(s) Shopify applied.
  //   Total    = cart.total_price (subtotal minus discount).
  function renderBreakdown(cart) {
    if (subtotalEl) subtotalEl.textContent = money(cart.original_total_price);
    if (!discountsEl) return;

    var rows = '';
    var apps = cart.cart_level_discount_applications || [];
    if (apps.length > 0) {
      apps.forEach(function (d) {
        var amount = d.total_allocated_amount || 0;
        if (amount <= 0) return;
        rows += '<div style="display:flex;justify-content:space-between;font-size:0.85rem;color:#3D8A5A;margin-bottom:0.4rem;">'
              +   '<span>' + (d.title || 'Box discount') + '</span>'
              +   '<span>&minus;' + money(amount) + '</span>'
              + '</div>';
      });
    } else if (cart.total_discount && cart.total_discount > 0) {
      // No per-discount detail available — show a single combined line.
      rows += '<div style="display:flex;justify-content:space-between;font-size:0.85rem;color:#3D8A5A;margin-bottom:0.4rem;">'
            +   '<span>Box discount</span>'
            +   '<span>&minus;' + money(cart.total_discount) + '</span>'
            + '</div>';
    }
    discountsEl.innerHTML = rows;
  }

  function openDrawer() {
    // Coordinate with the wishlist drawer (if open) so we don't double-
    // darken the page or re-animate when this drawer is already open.
    var coord = (window.GiddyDrawers && window.GiddyDrawers.beforeOpen('cart')) || {};

    // Position the drawer + overlay just below where the menu currently sits
    // in the viewport. If the menu is fixed at top:0, drawer starts at
    // headerHeight. If the menu is in normal flow (announcement bar visible),
    // drawer starts at announcement + header height — so the announcement bar
    // remains visible at the very top of the screen.
    var menuEl = document.querySelector('.header-wrapper');
    if (menuEl) {
      var menuBottom = Math.max(0, Math.round(menuEl.getBoundingClientRect().bottom));
      drawer.style.top = menuBottom + 'px';
      overlay.style.top = menuBottom + 'px';
    }

    // Hide the OTHER drawer's overlay so only one dim layer shows
    if (coord.hideOtherOverlay) {
      var otherOverlay = document.getElementById('giddy-wishlist-overlay');
      if (otherOverlay) { otherOverlay.style.opacity = '0'; otherOverlay.style.display = 'none'; }
    }

    overlay.style.display = 'block';
    setTimeout(function () { overlay.style.opacity = '1'; }, 10);
    // Only slide if not already open — coordinator returns animate=false
    // when this drawer was already in the open state (z-index swap only).
    if (coord.animate !== false) {
      drawer.style.transform = 'translateX(0)';
    }
    document.body.classList.add('giddy-drawer-open');
    loadCart();
  }

  function closeDrawer() {
    overlay.style.opacity = '0';
    drawer.style.transform = 'translateX(100%)';
    document.body.classList.remove('giddy-drawer-open');

    // Tell the coordinator we've closed; it returns whether the other
    // drawer is still open so we know to restore its overlay.
    var coord = (window.GiddyDrawers && window.GiddyDrawers.afterClose('cart')) || {};

    if (coord.showOtherOverlay) {
      // The wishlist drawer is still open — bring its overlay back so
      // it can be dismissed by clicking it.
      var otherOverlay = document.getElementById('giddy-wishlist-overlay');
      if (otherOverlay) {
        otherOverlay.style.display = 'block';
        requestAnimationFrame(function () { otherOverlay.style.opacity = '1'; });
      }
      // Skip the chat-bubble return — there's still a drawer holding it
      // off-screen, so we shouldn't rock it back.
      setTimeout(function () { overlay.style.display = 'none'; }, 350);
    } else {
      // No other drawer open: standard close, trigger chat-bubble return.
      document.body.classList.add('giddy-help-returning');
      setTimeout(function () {
        overlay.style.display = 'none';
        document.body.classList.remove('giddy-help-returning');
      }, 750);
    }
  }

  function updateHeaderCount(count) {
    // Scoped to the cart icon — the wishlist icon's bubble also has the
    // .cart-count-bubble class (shared styling) but its count is managed
    // independently from localStorage in giddy-wishlist.js.
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach(function (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = count;
      bubble.style.visibility = count > 0 ? 'visible' : 'hidden';
    });
  }

  // === Valid pack sizes (SINGLE COOKIES only) ===
  // Single cookies must be bought in multiples of 6; premade 6/12/18 packs
  // (and anything else) are exempt and never block checkout. /cart.js does
  // NOT expose product tags, so the authoritative, tag-aware count comes from
  // the giddy-pack-gate section (same Liquid logic as the full cart page),
  // fetched here via the Section Rendering API.
  function applyGate(valid, hintText) {
    var btn = document.getElementById('cart-drawer-checkout');
    var hint = document.getElementById('cart-drawer-pack-hint');
    if (btn) {
      if (valid) {
        btn.removeAttribute('aria-disabled');
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
        btn.style.background = '#E8956D';
        btn.style.color = '#fff';
        btn.style.boxShadow = '0 8px 24px rgba(232,149,109,0.35)';
        btn.setAttribute('href', '/checkout');
      } else {
        btn.setAttribute('aria-disabled', 'true');
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.55';
        btn.style.background = 'rgba(232,149,109,0.45)';
        btn.style.color = 'rgba(61,32,16,0.6)';
        btn.style.boxShadow = 'none';
        // Strip href so keyboard/touch can't navigate either
        btn.setAttribute('href', '#');
      }
    }
    if (hint) {
      hint.textContent = hintText || '';
      hint.style.display = hintText ? '' : 'none';
    }
  }

  // Pull the tag-aware gate state from the server and apply it. On ANY failure
  // we enable the button, so a network hiccup never traps a customer who has a
  // legitimately checkout-able cart.
  function refreshGate() {
    fetch('/cart?section_id=giddy-pack-gate', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var data = doc.querySelector('[data-giddy-pack-gate]');
        if (!data) { applyGate(true, ''); return; }
        applyGate(data.getAttribute('data-valid') === '1', data.getAttribute('data-hint') || '');
      })
      .catch(function () { applyGate(true, ''); });
  }

  function renderCart(cart) {
    lastCart = cart;
    if (loadingEl) loadingEl.style.display = 'none';
    updateHeaderCount(cart.item_count);

    if (cart.item_count === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      itemsEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    if (footerEl) footerEl.style.display = 'block';
    if (totalEl) totalEl.textContent = money(cart.total_price);
    renderBreakdown(cart);
    refreshGate();

    itemsEl.innerHTML = cart.items.map(function (item) {
      var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      var img = (item.featured_image && item.featured_image.url) ? item.featured_image.url : '';
      var keyAttr = item.key;
      return ''
        + '<div data-cart-row="' + keyAttr + '" data-unit-price="' + item.original_price + '" style="display:grid;grid-template-columns:72px 1fr auto;gap:1rem;align-items:start;padding:1rem 0;border-bottom:1px solid rgba(61,32,16,0.06);transition:opacity 0.2s;">'
        +   '<div style="width:72px;height:72px;border-radius:12px;overflow:hidden;background:#F5E6D8;flex-shrink:0;">'
        +     '<img src="' + img + '" style="width:100%;height:100%;object-fit:cover;" alt="' + item.product_title + '">'
        +   '</div>'
        +   '<div>'
        +     '<a href="' + item.url + '" style="font-family:\'Fraunces\',serif;font-size:0.9rem;font-weight:700;font-style:italic;color:#3D2010;text-decoration:none;display:block;margin-bottom:0.2rem;">' + item.product_title + '</a>'
        +     '<div style="font-size:0.75rem;color:#9A7860;margin-bottom:0.5rem;">' + variant + '</div>'
        +     '<div data-line-price style="font-size:0.88rem;font-weight:700;color:#E8956D;">' + money(item.original_line_price) + '</div>'
        +     '<div style="display:flex;align-items:center;gap:0.5rem;margin-top:0.5rem;">'
        +       '<button type="button" data-cart-key="' + keyAttr + '" data-qty-action="minus" aria-label="Decrease quantity" style="width:26px;height:26px;border-radius:50%;border:1.5px solid #E8C4A8;background:#fff;cursor:pointer;font-size:0.9rem;font-weight:700;color:#3D2010;display:flex;align-items:center;justify-content:center;transition:transform 0.1s, background 0.15s;">&minus;</button>'
        +       '<span data-qty-display style="font-size:0.85rem;font-weight:700;min-width:20px;text-align:center;transition:opacity 0.15s;">' + item.quantity + '</span>'
        +       '<button type="button" data-cart-key="' + keyAttr + '" data-qty-action="plus" aria-label="Increase quantity" style="width:26px;height:26px;border-radius:50%;border:1.5px solid #E8C4A8;background:#fff;cursor:pointer;font-size:0.9rem;font-weight:700;color:#3D2010;display:flex;align-items:center;justify-content:center;transition:transform 0.1s, background 0.15s;">+</button>'
        +     '</div>'
        +   '</div>'
        +   '<button type="button" data-cart-key="' + keyAttr + '" data-qty-action="remove" aria-label="Remove item" style="background:none;border:none;color:#C8B8A8;font-size:1.2rem;cursor:pointer;padding:0;line-height:1;margin-top:2px;">&times;</button>'
        + '</div>';
    }).join('');
  }

  function loadCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        if (loadingEl) loadingEl.textContent = 'Could not load cart.';
      });
  }

  function sendChange(key) {
    var p = pending[key];
    if (!p) return;
    var qty = p.finalQty;
    var controller = new AbortController();
    p.controller = controller;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
      signal: controller.signal
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Only clear pending if no newer click came in mid-flight
        if (pending[key] && pending[key].finalQty === qty) {
          delete pending[key];
        }
        renderCart(cart);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        delete pending[key];
        loadCart();
      });
  }

  function scheduleChange(key, newQty) {
    if (!pending[key]) pending[key] = {};
    var p = pending[key];
    p.finalQty = newQty;
    if (p.timer) clearTimeout(p.timer);
    if (p.controller) {
      try { p.controller.abort(); } catch (_) {}
      p.controller = null;
    }
    p.timer = setTimeout(function () { sendChange(key); }, DEBOUNCE_MS);
  }

  function applyOptimisticRow(row, newQty) {
    if (!row) return;
    var qtySpan = row.querySelector('[data-qty-display]');
    var priceEl = row.querySelector('[data-line-price]');
    var unitPrice = parseInt(row.getAttribute('data-unit-price'), 10) || 0;
    if (qtySpan) {
      qtySpan.textContent = newQty;
      qtySpan.style.opacity = '0.6';
    }
    // Full line price only — discounts are shown on the subtotal→total
    // breakdown, never per-cookie.
    if (priceEl) priceEl.textContent = money(unitPrice * newQty);
  }

  function applyOptimisticTotals() {
    if (!lastCart) return;
    var subtotal = 0;
    var count = 0;
    document.querySelectorAll('#cart-drawer-items [data-cart-row]').forEach(function (row) {
      var unit = parseInt(row.getAttribute('data-unit-price'), 10) || 0;
      var qty = parseInt(row.querySelector('[data-qty-display]').textContent, 10) || 0;
      subtotal += unit * qty;
      count += qty;
    });
    // Only the full-price SUBTOTAL can be computed optimistically — the
    // box discount + final total wait for the server's response (renderCart
    // fires after /cart/change.js returns). This keeps the displayed Total
    // accurate rather than briefly flashing the undiscounted figure.
    if (subtotalEl) subtotalEl.textContent = money(subtotal);
    updateHeaderCount(count);
  }

  itemsEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-key]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-cart-key');
    var action = btn.getAttribute('data-qty-action');
    var row = btn.closest('[data-cart-row]');

    // Remove (×) — fire immediately, no debounce. Optimistically hide the row.
    if (action === 'remove') {
      if (row) {
        row.style.opacity = '0';
        row.style.maxHeight = row.offsetHeight + 'px';
        setTimeout(function () { row.style.display = 'none'; applyOptimisticTotals(); }, 150);
      }
      pending[key] = { finalQty: 0 };
      sendChange(key);
      return;
    }

    // +/- — optimistic update + debounced server call
    var current = pending[key] && typeof pending[key].finalQty === 'number'
      ? pending[key].finalQty
      : (row ? (parseInt(row.querySelector('[data-qty-display]').textContent, 10) || 0) : 0);
    var next = action === 'plus' ? current + 1 : Math.max(0, current - 1);

    applyOptimisticRow(row, next);
    applyOptimisticTotals();
    scheduleChange(key, next);

    // tiny click animation
    btn.style.transform = 'scale(0.92)';
    setTimeout(function () { btn.style.transform = ''; }, 80);
  });

  // Close wiring
  var closeBtn = document.getElementById('cart-drawer-close');
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Open from the theme header's cart icon instead of navigating to /cart
  var cartIcon = document.getElementById('cart-icon-bubble');
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  // Any other script can open the drawer with: document.dispatchEvent(new Event('giddy:cart:open'))
  document.addEventListener('giddy:cart:open', openDrawer);

  // Keep the header cart count in sync on page load
  loadCart();
})();
